import { track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { ToolbarButton } from '../ToolbarButton'
import { Edit1 } from 'blaze-ui/icons'
import { DesktopTextEditButtonProps } from './Types'

const DesktopTextEditButton = track(
  observer(({ editor }: DesktopTextEditButtonProps) => {
    const selectedShape = editor.getOnlySelectedShape()

    if (!selectedShape) {
      return null
    }

    return (
      <ToolbarButton
        title="Edit"
        frontIcon={Edit1}
        onPress={() => {
          editor.setEditingShape(selectedShape)
          editor.setCurrentTool('select.editing_shape')
        }}
        aria-label="Edit"
      >
        Edit
      </ToolbarButton>
    )
  }),
)

export { DesktopTextEditButton }
